import isEmpty from 'lodash/isEmpty';
import { UserProfile } from './logged-user.types';

export const hasLanguageSet = ({ default_language: defaultLanguage }
: UserProfile) => !isEmpty(defaultLanguage);

export const getUserLanguage = (user: UserProfile): string => user.default_language;
